import AbsenceLabel from '@/components/ui/labels/AbsenceLabel';

import styles from './AbsencesDetailPanelHeader.module.scss';

interface OwnProps {
  title: string;
  label: string;
  isCreatedTeacher?: boolean;
  isConfirmed?: boolean;
}

const AbsencesDetailPanelHeader: React.FC<OwnProps> = ({
  title = '日付なし',
  label,
  isCreatedTeacher,
  isConfirmed,
}) => (
  <div className={styles.wrapper}>
    <div className={styles.panelHeader}>
      <h2 className={styles.date}>{title}</h2>
      {isCreatedTeacher ? (
        <span className={styles.label}>学校登録</span>
      ) : (
        isConfirmed && <span className={styles.confirmedLabel}>先生確認済</span>
      )}
    </div>
    <AbsenceLabel label={label} />
  </div>
);

export default AbsencesDetailPanelHeader;
